import "../components/widgets"

import "../components/scroll-up/scroll-up"
import "../components/modal/modal"
import "../components/counter/counter"

// Groups
import "../components/groups/herbals-group/herbals-group"
import "../components/groups/radio-boxes-group/radio-boxes-group"

// Items

import "../components/items/faq-item/faq-item"
import "../components/items/category-item/category-item"
import "../components/items/user-login-item/user-login-item"
import "../components/items/content-toggle-item/content-toggle-item"

// Forms

import "../components/forms/search-form/search-form"
import "../components/forms/discount-form/discount-form"

// Main header
import "../components/main-header/main-header"
import "../components/main-header/main-header-cart/main-header-cart"
import "../components/main-header/main-header-mobile/main-header-mobile"
import "../components/main-header/main-header-mobile-panel/main-header-mobile-panel"
import "../components/main-header/main-header-actions/main-header-actions"

// Boxes
import "../components/boxes/cart-overview-box/cart-overview-box"

//Fields
import "../components/fields/radio-box-field/radio-box-field"

//Cart
import "./cart-handle/cart-handle"
